/**
 * Partner type constants.
 *
 * IMPORTANT: Keep in sync with apps/api/src/utils/affiliateConfig.ts
 *
 * Partner types are users who receive payments from us (commissions).
 * They need additional declarations for autofactura compliance.
 * Non-partners (DEFAULT) only pay us, so declarations are not required.
 */

export const DEFAULT = "DEFAULT";
export const AMBASSADOR = "AMBASSADOR";
export const INFLUENCER = "INFLUENCER";
export const DISTRIBUTOR = "DISTRIBUTOR";

// All possible referrer types
export const REFERRER_TYPES = [DEFAULT, AMBASSADOR, INFLUENCER, DISTRIBUTOR];

// Partner types that receive payments from us (need declarations for autofactura)
export const PARTNER_TYPES = [AMBASSADOR, INFLUENCER, DISTRIBUTOR];

/**
 * Check if a referrer type is a partner type.
 * Partners receive payments from us and need autofactura declarations.
 *
 * @param {string} referrerType - The user's referrerType
 * @returns {boolean} True if the user is a partner
 */
export const isPartnerType = (referrerType: string) => PARTNER_TYPES.includes(referrerType);
